import { ColumnMetadata } from "@valg-shared/components/table/table/column-metadata";
import { TableDataItem } from "@valg-shared/components/table/table/table.component";
import { WithPropsOfType } from "@valg-shared/forms";

export interface MandateCandidateListItem extends TableDataItem {
  candidate: string;
  numberOfMandates: number;
}

export const CandidateListColumnDef: WithPropsOfType<MandateCandidateListItem, ColumnMetadata> = {
  candidate: {
    title: 'candidate_mandates.column.candidate',
    sortable: true
  },
  numberOfMandates: {
    title: 'candidate_mandates.column.number_of_mandates',
    sortable: true,
    rightAligned: true,
    defaultSort: "asc"
  },
  id: { title: 'id', disable: true },
};
